import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleColorTypeEnum } from '../enums/vehicle-color-type.enum';

/**
 * Vehicle colors filters
 */
export class VehicleColorsFilters extends ApiRequestFilters {
	/**
	 * Vehicle color type values
	 */
	types?: VehicleColorTypeEnum[];
}
